export const video = {
    init: () => {
        const $ = jQuery;

        $('#video-trigger, #trigger-video').on('click', (e) => {
            e.preventDefault();

            $('#modal-overlay').addClass('showing');
            $('body').addClass('disable-scroll');
        });

        $('#modal-overlay, #modal .close').on('click', (e) => {
            $('#modal-overlay').removeClass('showing');
            $('body').removeClass('disable-scroll');
        });
    }
}